<po-page-list #poPageListComponent
  p-title="Processo Cadastro"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="inclusaoDe"
      p-label="Inclusão de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.dInclusao_de"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="inclusaoAte"
      p-label="Inclusão até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.dInclusao_ate"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
    ></po-datepicker>
    <po-input class="po-sm-12 po-md-6 po-lg-6"
      name="cgc"
      p-label="CPF/CNPJ"
      [(ngModel)]="tabelaPrincipalFiltro.dados.cCGC"
    ></po-input>
    <po-select class="po-sm-12 po-md-3 po-lg-3"
      name="status"
      p-label="Status"
      [(ngModel)]="tabelaPrincipalFiltro.dados.cStatus"
      [p-options]="statusList"
      [p-required]="true"
    ></po-select>
    <po-select class="po-sm-12 po-md-3 po-lg-3"
      name="tipo"
      p-label="Tipo"
      [(ngModel)]="tabelaPrincipalFiltro.dados.cTipoINN"
      [p-options]="tipoList"
      [p-required]="true"
    ></po-select>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
      p-label="Usuário Solicitante"
      name="cUsuario"
      [(ngModel)]="tabelaPrincipalFiltro.dados.cUsuario"
      p-field-label="CUSRNOME"
      p-field-value="CUSRID"
      [p-columns]="usuarioColumnsFilters"
      [p-field-format]="usuarioFieldFormaterFilters"
      [p-filter-service]="usuarioLookupService"
      [p-advanced-filters]="usuarioAdvancedFilters"
      [p-literals]="{ modalTitle: 'Usuário' }"
    ></po-lookup>
  </form>
</po-modal>
